// const config = {
//   xsmall_min: 320,
//   xsmall_max: 543,
//   small_min: 544,
//   small_max: 767,
//   medium_min: 768,
//   medium_max: 1023,
//   large_min: 1024,
//   large_max: 1225,
//   xlarge_min: 1226,

//   // Breakpoints: Pixel Based. See corresponding Breakpoints in variables.less.
//   bp_xsmall_min: "320px",
//   bp_xsmall_max: "543px",
//   bp_small_min: "544px",
//   bp_small_max: "767px",
//   bp_medium_min: "768px",
//   bp_medium_max: "1023px",
//   bp_large_min: "1024px",
//   bp_large_max: "1225px",
//   bp_xlarge_min: "1226px",
// };

// config.bpem_xsmall_min = px2em(config.bp_xsmall_min);
// config.bpem_xsmall_max = px2em(config.bp_xsmall_max);
// config.bpem_small_min = px2em(config.bp_small_min);
// config.bpem_small_max = px2em(config.bp_small_max);
// config.bpem_medium_min = px2em(config.bp_medium_min);
// config.bpem_medium_max = px2em(config.bp_medium_max);
// config.bpem_large_min = px2em(config.bp_large_min);
// config.bpem_large_max = px2em(config.bp_large_max);
// config.bpem_xlarge_min = px2em(config.bp_xlarge_min);

// const px2em = function (px) {
//   return Math.round(
//     parseFloat(px) / 16 // pixel to em ratio
//     * 100) / 100
//     + 'em'; // add unit as string
// }

export const breakpointConfig = {
  "xsmall_min": 320,
  "xsmall_max": 543,
  "small_min": 544,
  "small_max": 767,
  "medium_min": 768,
  "medium_max": 1023,
  "large_min": 1024,
  "large_max": 1225,
  "xlarge_min": 1226,
  "bp_xsmall_min": "320px",
  "bp_xsmall_max": "543px",
  "bp_small_min": "544px",
  "bp_small_max": "767px",
  "bp_medium_min": "768px",
  "bp_medium_max": "1023px",
  "bp_large_min": "1024px",
  "bp_large_max": "1225px",
  "bp_xlarge_min": "1226px",
  "bpem_xsmall_min": "20em",
  "bpem_xsmall_max": "33.94em",
  "bpem_small_min": "34em",
  "bpem_small_max": "47.94em",
  "bpem_medium_min": "48em",
  "bpem_medium_max": "63.94em",
  "bpem_large_min": "64em",
  "bpem_large_max": "76.56em",
  "bpem_xlarge_min": "76.63em"
}